import { makeAutoObservable, runInAction } from "mobx";
import { COMPANY_ROLE_ENUM, COMPANY_STATUS_ENUM, CompanyEntity, WalletEntity } from "interfaces";
import { getCompanyById } from "services";
import { NormalizedError } from "services/api/errorHandler";
import { statusFetching } from "services/authClient/constants/types";

export class CompanyCardStore {
  public card: CompanyEntity & { wallets: WalletEntity[] } = {
    id: "",
    userCompanyDto: [],
    companyName: "",
    companyRegistrationNumber: "",
    inn: "",
    kpp: "",
    wallets: [],
    role: COMPANY_ROLE_ENUM.CUSTOMER,
    createdAt: "",
    address: "",
    status: COMPANY_STATUS_ENUM.DRAFT,
    statusDate: "",
    documents: {},
    defaultQuoteExpDuration: {},
    isResident: false,
    type: "COMPANY",
    defaultBankAccountDetails: {
      id: "",
      accountName: "",
      bankName: "",
      bankRegistrationNumber: "",
      bik: "",
      accountNumber: "",
      correspondentAccount: "",
      isDefault: false,
      isArchived: false,
    },
    isForeignOrg: false,
    isOnlyTaxResidentRF: false,
    isControlPersonsRF: false,
    phone: "",
    email: "",
    contractNumber: "",
    contractDate: "",
    beneficiaryCreated: false,
  };
  public fetchStatus: statusFetching = "init";
  public fetchError?: NormalizedError;

  constructor() {
    makeAutoObservable(this);
  }

  get isPending() {
    return this.fetchStatus === "fetching";
  }

  fetchCompanyCardById = async (id: string) => {
    runInAction(() => {
      this.fetchStatus = "fetching";
      this.fetchError = undefined;
    });

    return getCompanyById({ id })
      .then((res) => {
        runInAction(() => {
          this.card = res;
          this.fetchStatus = "success";
        });
        return res;
      })
      .catch((error: NormalizedError) => {
        runInAction(() => {
          this.fetchStatus = "error";
          this.fetchError = error;
        });
      });
  };

  updateCardById = async (id: string) => {
    return getCompanyById({ id })
      .then((res) => {
        runInAction(() => {
          this.card = res;
        });
      })
      .catch((error: NormalizedError) => {
        runInAction(() => {
          this.fetchStatus = "error";
          this.fetchError = error;
        });
      });
  };
}
